// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-item-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-small);
  width: 88px;
  height: 20px;
  padding: var(--spacing-small);
  border-radius: var(--border-radius-primary) !important;
  border: var(--border-width) solid var(--color-border);
}
.cart-item-counter.hide-border {
  border: var(--border-width) solid transparent;
}
.cart-item-counter .vert-paragraph {
  font-size: var(--font-paragraph) !important;
  font-weight: 600;
  line-height: var(--font-paragraph-line) !important;
  color: var(--color-neutral-dark-darker) !important;
  cursor: auto;
}
.cart-item-counter .vert-icon svg {
  width: 12px;
  height: 12px;
}
.cart-item-counter .vert-icon.less svg {
  fill: var(--color-detached);
}
.cart-item-counter .vert-icon.less.disabled svg {
  fill: var(--color-neutral-light);
}
.cart-item-counter .vert-icon.more svg {
  fill: var(--color-detached);
}
.cart-item-counter .vert-icon.more.disabled svg {
  fill: var(--color-neutral-light);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartItemCounterStyles.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,WAAA;EACA,YAAA;EACA,6BAAA;EAEA,sDAAA;EACA,qDAAA;AADJ;AAGI;EACI,6CAAA;AADR;AAbA;EAkBQ,2CAAA;EACA,gBAAA;EACA,kDAAA;EACA,kDAAA;EACA,YAAA;AAFR;AApBA;EA2BY,WAAA;EACA,YAAA;AAJZ;AAOQ;EAEQ,2BAAA;AANhB;AAQY;EAEQ,gCAAA;AAPpB;AAYQ;EAEQ,2BAAA;AAXhB;AAaY;EAEQ,gCAAA;AAZpB","sourcesContent":[".cart-item-counter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing-small);\n\n    width: 88px;\n    height: 20px;\n    padding: var(--spacing-small);\n\n    border-radius: var(--border-radius-primary) !important;\n    border: var(--border-width) solid var(--color-border);\n\n    &.hide-border {\n        border: var(--border-width) solid transparent;\n    }\n\n    .vert-paragraph {\n        font-size: var(--font-paragraph) !important;\n        font-weight: 600;\n        line-height: var(--font-paragraph-line) !important;\n        color: var(--color-neutral-dark-darker) !important;\n        cursor: auto;\n    }\n\n    .vert-icon {\n        svg {\n            width: 12px;\n            height: 12px;\n        }\n\n        &.less {\n            svg {\n                fill: var(--color-detached);\n            }\n            &.disabled {\n                svg {\n                    fill: var(--color-neutral-light);\n                }\n            }\n        }\n\n        &.more {\n            svg {\n                fill: var(--color-detached);\n            }\n            &.disabled {\n                svg {\n                    fill: var(--color-neutral-light);\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
